import { Sparkle } from '@phosphor-icons/react';
import { motion } from 'framer-motion';

interface ThinkingMessageProps {
    label?: string;
    withDelay?: boolean;
}

const WaveDots = () => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        {[0, 1, 2].map((i) => (
            <motion.span
                key={i}
                animate={{ y: [0, -4, 0], opacity: [0.4, 1, 0.4] }}
                transition={{ duration: 1.4, repeat: Infinity, delay: i * 0.2, ease: 'easeInOut' }}
                style={{
                    display: 'inline-block',
                    width: 5,
                    height: 5,
                    borderRadius: '50%',
                    background: '#6366f1',
                }}
            />
        ))}
    </div>
);

const ThinkingMessage = ({ withDelay = false }: ThinkingMessageProps) => (
    <motion.div
        className="w-full"
        initial={{ y: 5, opacity: 0 }}
        animate={{ y: 0, opacity: 1, transition: { delay: withDelay ? 0.5 : 0 } }}
    >
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, paddingLeft: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                <Sparkle size={10} weight="fill" color="#6366f1" />
                <span style={{
                    fontSize: 10,
                    fontWeight: 700,
                    color: '#6366f1',
                    letterSpacing: '0.06em',
                    textTransform: 'uppercase',
                }}>
                    Reparo AI
                </span>
            </div>
            <WaveDots />
        </div>
    </motion.div>
);

export default ThinkingMessage;
